<template>
   <div v-if="isSupportIntercom !== undefined">
      <!-- Intercom support -->
      <DefaultButton
         v-if="isSupportIntercom"
         :size="size"
         :text="text"
         :color="color"
         :styleType="styleType"
         :roundedEdges="roundedEdges"
         :isDisabled="isDisabled"
         @click="intercom.open()"
      />
      <!-- Org email support (should always exist as a backup) -->
      <LinkButton
         v-else
         is-external
         :url="`mailto:${organisationInfo.email}`"
         :size="size"
         :text="text"
         :color="color"
         :styleType="styleType"
         :roundedEdges="roundedEdges"
         :isDisabled="isDisabled"
      />
   </div>
</template>

<script setup lang="ts">
import { intercomKey } from "@/plugins/useIntercom";
import { useBaseContentStore } from "@/stores/baseContentStore";
import { type ButtonTheme } from "@/types";

const intercom = inject(intercomKey);
const baseContentStore = useBaseContentStore();

// lifecycle
// -----------------------------------------
defineProps<{
   size?: "sm" | "md" | "lg";
   roundedEdges?: "full" | "md";
   isDisabled?: boolean;
   color?: ButtonTheme;
   styleType?: "filled" | "outlined" | "ghost";
   text: string;
}>();

// Computed
// -----------------------------------------
const organisationInfo = computed(() => {
   if (!baseContentStore.content) return null;

   return baseContentStore.content.organisationInfo;
});
const isSupportIntercom = computed(() => {
   if (intercom?.isActive) {
      return true;
   } else if (organisationInfo.value?.email) {
      return false;
   } else {
      console.error("No support buttons available on Portal - Intercom and Org Email are both missing.");
      return undefined;
   }
});
</script>

<style scoped></style>
